export const INSTANCE_MANAGEMENT_CONSTS = {
  moduleName: 'epb-instance-management',

  getters: {
    serviceConfigs: 'serviceConfigs',
    searchServiceConfig: 'searchServiceConfig',
  },

  actions: {
    requestNewInstance: 'requestNewInstance',

    listServiceConfigs: 'listServiceConfigs',
    readSearchServiceConfig: 'readSearchServiceConfig',
    updateServiceConfig: 'updateServiceConfig',
    updateSearchServiceConfig: 'updateSearchServiceConfig',
    setEnabledServiceConfig: 'setEnabledServiceConfig',
  },

  mutations: {
    setServiceConfigs: 'setServiceConfigs',
    setSearchServiceConfig: 'setSearchServiceConfig',
    updateServiceConfig: 'updateServiceConfig',
  },
}
